module.exports = __webpack_public_path__ + "static/img/bg-6.35a1c1c3.png";